import { NSARouterMakerResult } from "namirasoft-account-react";
import { NotificationSenderLayout } from '../NotificationSenderLayout';
import { NotificationSenderEntity } from '../NotificationSenderEntity';
import { NotificationSenderProps } from '../NotificationSenderProps';

interface TopicViewPageProps extends NSARouterMakerResult, NotificationSenderProps
{ }

export default function TopicViewPage(props: TopicViewPageProps) 
{
    return (
        <NotificationSenderLayout
            {...props}
            action={{
                description: "This section displays detailed information about a selected topic, including its configuration and related subscribers."
            }}
            pages={{
                entity: NotificationSenderEntity.Topic(props),
                view: {}
            }}
        >
            <></>
        </NotificationSenderLayout >
    );
};